'use client'

import React, { memo } from 'react'
import { useTranslations } from 'next-intl'

import { Arrow, ItemSelectIcon } from '@/components/icons'
import { Button, Form, FormControl, FormField, FormItem, FormMessage, Input } from '@/ui'

import useCheckoutCoupon from '../../../../../../hooks/checkout/useCheckoutCoupon'

const CouponCode = () => {
  const { form, handleApply, handleCancel, isApply, cartAppliedCoupons } = useCheckoutCoupon()
  const t = useTranslations('Cart')

  return (
    <div>
      {isApply ? (
        <div className="border-b border-[#E9E9E9] pb-6">
          <p className="mb-3 text-[16px] text-[#0F0F0F]">{t('discount_code_applied')} </p>
          {cartAppliedCoupons?.map((coupon, index) => (
            <div
              key={`${coupon?.code}_${index}`}
              className="mt-6 flex items-center justify-between">
              <div className="flex items-center">
                <span className="mr-2 text-[#444446]">{coupon?.code ?? ''}</span>
                <ItemSelectIcon />
              </div>
              <div onClick={handleCancel} className="cursor-pointer text-[#0F0F0F]">
                {t('remove')}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <>
          <p className="mb-3 font-miSansDemiBold450 text-[16px] xl:mb-4">
            {t('have_discount_code')}
          </p>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(handleApply)} className="grid grid-cols-[1fr_40px]">
              <FormField
                control={form.control}
                name="coupon_code"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Input
                        label={t('enter_your_discount_code')}
                        className="h-[44px] rounded-r-none border-none bg-[#F8F8F9] xl:h-[40px]"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button
                type="submit"
                className="flex h-[44px] w-full cursor-pointer items-center justify-center !rounded-bl-none !rounded-br-[8px] !rounded-tl-none !rounded-tr-[8px] bg-[#000000] p-0 text-[13px] text-white hover:bg-[#0F0F0F] focus:bg-[#000000] active:bg-[#000000] xl:h-[40px]">
                <Arrow color="#fff" />
              </Button>
            </form>
          </Form>
        </>
      )}
    </div>
  )
}

export default memo(CouponCode)
